import axios from '@/libs/axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDominios(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/dominio/findAll', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchDominio(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/dominio/findOne/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addDominio(ctx, dominioData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/dominio/create', dominioData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    putDominio(ctx, dominioData) {
      return new Promise((resolve, reject) => {
        axios
          .put('/dominio/update', dominioData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeDominio(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/dominio/delete/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
